export default {
  metadata: {
    version: '2.0.0',
    id: 'input-field-2.0.0',
    name: 'JDSInputFieldV2'
  },
  hierarchy: {
    container: [
      {
        'label-container': ['input_label-jds-text', 'info-slot']
      },
      {
        'input-container': ['prefix-slot', 'jds_input', 'suffix-slot']
      },
      {
        'helper-container': ['jds_feedback_block', 'helper-jds-text']
      },
      {
        'dynamic-container': ['dynamic-jds-text', 'dynamic-jds_action_button']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{i_1}',
      width: '{i_2}',
      'justify-content': '{i_3}',
      'align-items': '{i_4}',
      opacity: '{i_5}',
      gap: '{i_9}'
    },
    'label-container': {
      'flex-direction': '{i_6}',
      'justify-content': '{i_7}',
      'align-items': '{i_8}',
      gap: '{i_9}'
    },
    'input-container': {
      'flex-direction': '{i_13}',
      'justify-content': '{i_14}',
      'align-items': '{i_15}',
      width: '{i_16}',
      height: '{i_17}',
      gap: '{i_18}',
      'padding-left': '{i_19}',
      'padding-right': '{i_20}',
      'border-width': '{i_23}',
      'border-color': '{i_24}',
      'border-radius': '{i_25}',
      behavior: {
        hover: {
          'border-color': '{i_26}'
        },
        active: {
          'border-color': '{i_27}'
        },
        focus: {
          'border-color': '{i_28}'
        }
      }
    },
    jds_input: {
      type: 'text',
      textAlign: '{i_29}',
      rows: 1,
      flex: 1
    },
    'helper-container': {
      'flex-direction': '{i_30}',
      'justify-content': '{i_31}',
      'align-items': '{i_32}',
      gap: '{i_33}'
    },
    jds_feedback_block: {
      size: 's',
      state: 'none',
      alignment: 'top'
    },
    'dynamic-container': {
      'flex-direction': '{i_38}',
      'justify-content': '{i_39}',
      'align-items': '{i_40}',
      gap: '{i_34}',
      hidden: false
    },
    'dynamic-jds_action_button': {
      kind: 'tertiary',
      size: 'small'
    },
    'input_label-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      textType: 'label',
      maxLines: 1
    },
    'helper-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    },
    'dynamic-jds-text': {
      'font-family': '{text_147}',
      color: '{text_22}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    _hasDynamic: {
      false: {
        'dynamic-container': {
          hidden: true
        }
      }
    },
    _noPrefix: {
      true: {
        'input-container': {
          'padding-left': '{i_0}'
        }
      }
    },
    disabled: {
      true: {
        container: {
          opacity: '{i_43}',
          disabled: true
        },
        jds_input: {
          disabled: true
        },
        'prefix-slot': {
          disabled: true
        },
        'suffix-slot': {
          disabled: true
        }
      }
    },
    state: {
      success: {
        'input-container': {
          'border-color': '{i_44}',
          behavior: {
            hover: {
              'border-color': '{i_45}'
            },
            focus: {
              'border-color': '{i_46}'
            },
            active: {
              'border-color': '{i_47}'
            }
          }
        },
        jds_feedback_block: {
          state: 'success'
        }
      },
      error: {
        'input-container': {
          'border-color': '{i_48}',
          behavior: {
            hover: {
              'border-color': '{i_49}'
            },
            focus: {
              'border-color': '{i_50}'
            },
            active: {
              'border-color': '{i_51}'
            }
          }
        },
        jds_feedback_block: {
          state: 'error'
        }
      },
      warning: {
        'input-container': {
          'border-color': '{i_52}',
          behavior: {
            hover: {
              'border-color': '{i_53}'
            },
            focus: {
              'border-color': '{i_54}'
            },
            active: {
              'border-color': '{i_55}'
            }
          }
        },
        jds_feedback_block: {
          state: 'warning'
        }
      }
    },
    size: {
      small: {
        'input-container': {
          height: '{i_56}'
        }
      },
      large: {
        'input-container': {
          height: '{i_59}',
          gap: '{i_60}',
          'padding-left': '{i_61}',
          'padding-right': '{i_62}'
        },
        jds_feedback_block: {
          size: 'l'
        },
        'input_label-jds-text': {
          'font-family': '{text_132}',
          'font-size': '{text_131}',
          'line-height': '{text_133}',
          'letter-spacing': '{text_134}',
          'font-weight': '{text_135}'
        },
        'helper-jds-text': {
          'font-family': '{text_132}',
          'font-size': '{text_131}',
          'line-height': '{text_133}',
          'letter-spacing': '{text_134}',
          'font-weight': '{text_135}'
        },
        'dynamic-jds-text': {
          'font-family': '{text_132}',
          'font-size': '{text_131}',
          'line-height': '{text_133}',
          'letter-spacing': '{text_134}',
          'font-weight': '{text_135}'
        }
      }
    },
    type: {
      email: {
        jds_input: {
          type: 'email'
        }
      },
      number: {
        jds_input: {
          type: 'number'
        }
      },
      password: {
        jds_input: {
          type: 'password'
        }
      },
      pin: {
        jds_input: {
          type: 'number',
          letterSpacing: 12,
          textAlign: 'center'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    children: {
      'prefix-slot': {
        name: 'prefix',
        accepts: ['jds_text', 'jds_icon', 'jds_input_phone_dropdown'],
        function: true
      },
      'suffix-slot': {
        name: 'suffix',
        accepts: ['jds_button', 'jds_icon', 'jds_spinner'],
        function: true
      },
      'info-slot': {
        name: 'info',
        accepts: ['any'],
        max: 1
      }
    },
    config: {
      _hasDynamic: {
        values: [true, false]
      },
      _noPrefix: {
        values: [true, false]
      },
      state: {
        type: 'JDSFeedbackBlock.state',
        values: ['none', 'success', 'error', 'warning']
      },
      size: {
        values: ['medium', 'small', 'large']
      },
      type: {
        values: ['text', 'email', 'number', 'password', 'pin']
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      jds_input: {
        id: {
          type: 'string',
          name: 'id',
          platform: 'web'
        },
        value: {
          type: 'string',
          name: 'value'
        },
        name: {
          type: 'string',
          name: 'name'
        },
        autoFocus: {
          type: 'boolean',
          name: 'autoFocus',
          platform: 'web'
        },
        placeholder: {
          type: 'string',
          name: 'placeholder'
        },
        maxLength: {
          type: 'number',
          name: 'maxLength'
        },
        pattern: {
          type: 'string',
          name: 'pattern'
        },
        required: {
          type: 'boolean',
          name: 'required'
        },
        focusRequester: {
          type: 'focusRequester',
          name: 'focusRequester',
          platform: 'android'
        },
        imeAction: {
          type: 'imeAction',
          name: 'imeAction',
          platform: 'android'
        },
        capitalization: {
          type: 'keyboardCapitalization',
          name: 'capitalization',
          platform: 'android'
        }
      },
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'stateText'
        }
      },
      'dynamic-jds_action_button': {
        label: {
          type: 'string',
          name: 'dynamicButtonText'
        }
      },
      'input_label-jds-text': {
        value: {
          type: 'string',
          name: 'label',
          function: true
        },
        id: {
          type: 'string',
          name: 'id',
          platform: 'web'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText'
        }
      },
      'dynamic-jds-text': {
        value: {
          type: 'string',
          name: 'dynamicText'
        }
      }
    },
    events: {
      jds_input: {
        onFocus: 'onFocus',
        onBlur: 'onBlur',
        onChange: 'onChange',
        onKeydown: {
          name: 'onKeydown',
          platform: 'web'
        },
        onInvalid: 'onInvalid',
        onSubmit: 'onSubmit'
      },
      'prefix-slot': {
        onClick: 'onPrefixClick'
      },
      'suffix-slot': {
        onClick: 'onSuffixClick'
      },
      'dynamic-jds_action_button': {
        onClick: 'onButtonClick'
      }
    },
    a11y: {
      jds_input: {
        properties: {
          ariaLabel: {
            name: 'ariaLabel',
            prop: 'label'
          },
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          ariaInvalid: 'ariaInvalid',
          ariaPlaceholder: {
            name: '_ariaplaceholder',
            prop: 'placeholder'
          },
          ariaRequired: {
            name: '_ariaRequired',
            prop: 'required'
          }
        }
      },
      'dynamic-jds_action_button': {
        properties: {
          ariaLabel: {
            name: 'dynamicButtonAriaLabel',
            prop: 'dynamicButtonText'
          },
          ariaDescribedby: {
            name: 'dynamicButtonAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
